// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3DGd6","content":"content__vU6fV","info":"info__3Mact","left":"left__RQHDk","title":"title__14l6I","description":"description__1voz9","picture":"picture__1jfcA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Section/styles.scss
// module id = 258
// module chunks = 0